import { render, staticRenderFns } from "./PublicPageMenuExternalEntry.vue?vue&type=template&id=d8a87a02"
import script from "./PublicPageMenuExternalEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPageMenuExternalEntry.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports